import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrackeritemDeleteModalComponent } from './trackeritem.delete.modal.component';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-delete-button',
  template: require('./trackeritem.delete.button.component.html')
})
export class TrackeritemDeleteButtonComponent implements OnInit {
  @Input() trackeritem: any;
  @Input() acls: any;

  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();

  btnStyle: string;

  tiDeleteModalOptions: any;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
    this.btnStyle = _.get(this.tiDeleteModalOptions, 'styling.deleteButton', 'btn-default');
  }

  showDelete() {
    const modalRef = this.modalService.open(TrackeritemDeleteModalComponent);
    modalRef.componentInstance.trackeritem = this.trackeritem;
    modalRef.componentInstance.onClose = () => {
        modalRef.close();
    };
    modalRef.componentInstance.onDelete = () => {
      modalRef.close();
      this.onDelete.emit();
    };
  }
}
